(() => {
  if (window.vitalGoogleReviewsV2) return;
  window.vitalGoogleReviewsV2 = true;
  const loaded = new Map(), pending = new Set();
  const endpointValid = value => /^\/(?:[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/)?(apps|a|tools|community)\/[a-zA-Z0-9_-]+$/.test(value);
  function endpointFor(element) { return (element.dataset.endpoint || '').replace(/\/$/, ''); }
  async function request(endpoint, action, params, options = {}) {
    if (!endpointValid(endpoint)) throw new Error('Reviews are not connected yet.');
    const query = new URLSearchParams({action, ...params});
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 25000);
    try {
      const response = await fetch(endpoint + '?' + query, {credentials:'same-origin', cache:'no-store', signal:controller.signal, ...options});
      let data; try { data = await response.json(); } catch (_) { throw new Error('Reviews are temporarily unavailable. Please try again later.'); }
      if (!response.ok || !data.ok) { const error = new Error(data.error || 'Reviews are temporarily unavailable.'); error.status = Number(data.status || response.status); throw error; }
      return data;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('The review service is taking longer than expected. Please try again.');
      throw error;
    } finally { clearTimeout(timer); }
  }
  function paint(product, value, failed = false) {
    document.querySelectorAll('[data-vital-rating-product]').forEach(badge => {
      if (badge.dataset.vitalRatingProduct !== product) return;
      const fill = badge.querySelector('.vital-rating-fill'), label = badge.querySelector('[data-vital-rating-label]');
      if (!fill || !label) return;
      if (failed) {label.textContent = 'Reviews unavailable';badge.setAttribute('aria-label','Reviews temporarily unavailable');return;}
      const count = Number(value.count), average = Number(value.average);
      if (!Number.isInteger(count) || count < 0 || !Number.isFinite(average) || average < 0 || average > 5) return;
      fill.style.width = (average * 20) + '%';
      label.textContent = count ? average.toFixed(1) + ' (' + count + ')' : 'No reviews yet';
      badge.setAttribute('aria-label', count ? 'Rated '+average.toFixed(1)+' out of 5 from '+count+' reviews' : 'No reviews yet. View product reviews');
    });
  }
  async function loadCardRatings() {
    const groups = new Map();
    document.querySelectorAll('[data-vital-rating-product]').forEach(badge => {
      const id=badge.dataset.vitalRatingProduct, endpoint=endpointFor(badge), key=endpoint+'|'+id;
      if (loaded.has(key)) {paint(id,loaded.get(key));return;}
      if (pending.has(key) || !/^\d{1,20}$/.test(id) || !endpointValid(endpoint)) return;
      if(!groups.has(endpoint))groups.set(endpoint,new Set()); groups.get(endpoint).add(id);
    });
    for (const [endpoint, idsSet] of groups) {
      const ids = [...idsSet];
      for(let i=0;i<ids.length;i+=40){
        const batch=ids.slice(i,i+40); batch.forEach(id=>pending.add(endpoint+'|'+id));
        try {
          const data=await request(endpoint,'summary',{products:batch.join(',')});
          batch.forEach(id=>{if(data.ratings && data.ratings[id]){loaded.set(endpoint+'|'+id,data.ratings[id]);paint(id,data.ratings[id]);}else paint(id,null,true);});
        } catch (_) {batch.forEach(id=>paint(id,null,true));}
        finally {batch.forEach(id=>pending.delete(endpoint+'|'+id));}
      }
    }
  }
  function text(tag, value, css) {const node=document.createElement(tag);node.textContent=value;if(css)node.className=css;return node;}
  function init(root) {
    if(root.dataset.ready)return;root.dataset.ready='true';
    const product=root.dataset.product, endpoint=endpointFor(root), form=root.querySelector('[data-review-form]');
    const status=root.querySelector('[data-review-status]'),more=root.querySelector('[data-review-more]'),list=root.querySelector('[data-review-list]'),summary=root.querySelector('[data-review-summary]'),login=root.querySelector('[data-review-login]');
    const seen=new Set(); let token='',page=0,busy=false;
    function render(review){
      if(seen.has(review.id)||!Number.isInteger(review.rating)||review.rating<1||review.rating>5)return;
      seen.add(review.id);const article=document.createElement('article');article.className='vital-review-entry';
      const stars=text('div','★'.repeat(review.rating)+'☆'.repeat(5-review.rating),'vital-review-entry-stars');stars.setAttribute('aria-label',review.rating+' out of 5 stars');
      const date=new Date(review.date),label=review.name+(Number.isNaN(date.getTime())?'':' · '+date.toLocaleDateString());
      article.append(stars,text('h3',review.title),text('p',label,'vital-review-meta'),text('p',review.body,'vital-review-body'));list.append(article);
    }
    async function load(){
      if(busy)return;busy=true;more.disabled=true;status.textContent='';
      try{
        const data=await request(endpoint,'reviews',{product,page:String(page+1)});
        data.reviews.forEach(render);page++;more.hidden=!data.hasMore;more.textContent='Load more reviews';
        summary.textContent=data.count?Number(data.average).toFixed(1)+' out of 5 · '+data.count+' review'+(data.count===1?'':'s'):'No reviews yet. Be the first to share your experience.';
        loaded.set(endpoint+'|'+product,data);paint(product,data);
      }catch(error){status.textContent=error.message;more.hidden=false;more.textContent='Try loading reviews again';summary.textContent='';}
      finally{busy=false;more.disabled=false;}
    }
    async function session(){
      try{const data=await request(endpoint,'session',{product});token=data.token;form.hidden=false;login.hidden=true;}
      catch(error){form.hidden=true;if(error.status===401)login.hidden=false;else status.textContent=error.message;}
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();const button=form.querySelector('button[type="submit"]'),message=form.querySelector('[data-review-submit-status]');
      button.disabled=true;message.textContent='Submitting…';const data=Object.fromEntries(new FormData(form));data.rating=Number(data.rating);data.token=token;
      try{
        const result=await request(endpoint,'submit',{product},{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
        message.textContent=result.message;form.querySelectorAll('input,textarea').forEach(el=>el.disabled=true);button.textContent='Submitted';
      }catch(error){message.textContent=error.message;button.disabled=false;if(error.status===403)await session();}
    });
    more.addEventListener('click',load);load();session();
  }
  function all(){document.querySelectorAll('[data-vital-reviews]').forEach(init);loadCardRatings();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();
  document.addEventListener('shopify:section:load',all);
  let timer;
  new MutationObserver(records=>{
    if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches('[data-vital-rating-product],[data-vital-reviews]')||node.querySelector('[data-vital-rating-product],[data-vital-reviews]'))))){clearTimeout(timer);timer=setTimeout(all,150);}
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
